export var formatAsNumber = new Intl.NumberFormat();

export var previousCartContainerHeight = null;

export var membershipCartCookieName = 'membershipCart_v3';
export var digitalAdvertisingCartCookieName = 'digitalAdvertisingCart_v2';

var xSVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 45"><defs><style>.cls-1{fill:none;stroke:#fff;stroke-miterlimit:10;}</style></defs><title>cy-x</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><circle class="cls-1" cx="22.5" cy="22.5" r="22"/><line class="cls-1" x1="15.88" y1="15.88" x2="29.12" y2="29.12"/><line class="cls-1" x1="15.88" y1="29.12" x2="29.12" y2="15.88"/></g></g></svg>';
var checkmarkSVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 77.42 77.42"><defs><style>.cls-1{fill:none;stroke:#ccc;stroke-miterlimit:10;}</style></defs><title>cy-checkmark</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><circle class="cls-1" cx="38.71" cy="38.71" r="38.21" transform="translate(-6.62 69.4) rotate(-79.1)"/><polyline class="cls-1" points="23.17 41.6 32.48 50.91 55.01 28.37"/></g></g></svg>';

export var items = {
    website_membership: {
        basicMembership: {
            planCode: 'website_membership',
            title: 'Website Membership',
            price: 150,
            monthly: true
        }
    },
    support: {
        thirtyMins: {
            title: '30 Minutes of Support Time',
            note: 'Included in website membership',
            minutes: 30,
            price: 0,
            monthly: true
        },
        oneHour: {
            title: '+1 Hour of Support Time',
            minutes: 60,
            price: 125,
            monthly: true
        },
        twoHours: {
            title: '+2 Hours of Support Time',
            minutes: 120,
            price: 225,
            monthly: true
        },
        fourHours: {
            title: '+4 Hours of Support Time',
            minutes: 240,
            price: 375,
            monthly: true
        },
        hourly: {
            title: 'Per-hour Billable Rate',
            minutes: 0,
            price: 150,
            monthly: false
        }
    },
    membershipDetails: {
        emails: {
            title: 'Email Account',
            note: '1 Included in website membership',
            price: 12,
            monthly: true,
            allowMultiple: true
        },
        domains: {
            title: 'Domain Name',
            note: '1 Included in website membership',
            price: 3,
            monthly: true,
            allowMultiple: true
        },
        eCommerce: {
            title: 'E-commerce',
            price: 175,
            monthly: true
        },
    },
    facebook: {
        facebookManagement: {
            planCode: 'facebook-subscription-2022',
            title: 'Facebook/Instagram Campaign Management',
            price: 300,
            monthly: true
        },
        facebookCampaign: {
            planCode: 'facebook-setup-only-2022',
            title: 'Facebook/Instagram Campaign Build',
            price: 1950,
            monthly: false
        }
    },
    google: {
        googleManagement: {
            planCode: 'google-subscription-2022',
            title: 'Google Ads Campaign Management',
            price: 200,
            monthly: true
        },
        googleCampaign: {
            planCode: 'google-setup-only-2022',
            title: 'Google Ads Campaign Build',
            price: 1700,
            monthly: false
        }
    }
}


export var digitalAdvertisingCart = {
    dueMonthly: 0,
    dueToday: 0,
    items: {
        "google": {},
        "facebook": {}
    }
}
export var membershipCart = {
    dueMonthly: 150,
    dueToday: 150,
    discount: false,
    items: {
        "website_membership": items.website_membership,
        "membershipDetails": {
            "emails": {
                "quantity": 0
            },
            "domains": {
                "quantity": 0
            }
        }
    },
    planCodes: []
}
export var formatAsCurrency = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
});
export function nth(d) {
	if (d > 3 && d < 21) return 'th';
	switch (d % 10) {
		case 1:  return "st";
		case 2:  return "nd";
		case 3:  return "rd";
		default: return "th";
	}
}
export function getCookie(name) {
    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? JSON.parse(v[2]) : null;
}
export function setCookie(name, value, days) {
    var d = new Date;
    d.setTime(d.getTime() + 24*60*60*1000*days);
    document.cookie = name + "=" + JSON.stringify(value) + ";path=/;expires=" + d.toGMTString();
}
export function deleteCookie(name) { setCookie(name, '', -1); }

export function smoothScrollTo(targetTop, onComplete = null) {
    window.scrollTo({
        top: targetTop,
        behavior: 'smooth'
    });

    let lastY = null;
    let sameCount = 0;

    function check() {
        const y = window.pageYOffset;

        if (y === lastY) {
            sameCount++;
            if (sameCount > 3) {
                onComplete();
                return;
            }
        } else {
            sameCount = 0;
            lastY = y;
        }

        requestAnimationFrame(check);
    }

    if ( onComplete != null ) {
        requestAnimationFrame(check);
    }
}

/**
 * @function cy_dispatchEvent
 * @param {target}  HTMLelement document or html element to listen for event
 * @param {name}	String	event name
 * @param {data}	Object	data to send with the event
 */
export function cy_dispatchEvent(target, name, data = {}) {
    target.dispatchEvent(
        new CustomEvent(name, {
            bubbles: true,
            detail: data
        })
    )
}

export function removeDiscountsFromCart() {
    var now = new Date();
    var month = now.toLocaleString('default', {month: 'long'});
    var day = now.toLocaleString('default', {day: 'numeric'});
    var year = now.toLocaleString('default', {year: 'numeric'});
    var todays_date = month + ' ' + day + nth(day) +  ' ' + year;
    var signup_form = document.querySelector('#membership-signup');
    getCart().discount = false;
    jQuery('#free-trial-subscription-note').remove();
    jQuery('.couponTimelineNotice').text('');
    jQuery('#irrelevantForFreeTrialsWithoutOneTimeCharges').show();
    jQuery('.todays-date').text(todays_date);
    jQuery('#billingDate').text(day + nth(day));
    jQuery('#when-charge').text('today');
    calculateCartTotals();
}

export function getCart() {
    return isDigitalAdsCheckout() ? digitalAdvertisingCart : membershipCart;
}

export function resetCart() {
    if (!isDigitalAdsCheckout()) {
        deleteCookie(membershipCartCookieName);
    } else {
        deleteCookie(digitalAdvertisingCartCookieName);
    }
}

/**
 * @function isDigitalAdsCheckout
 * Checks whether the current sign up page is for digital advertisment addons only.
 * @return bool
 */
export function isDigitalAdsCheckout() {
    var params = window.location.search;
    var urlParams = new URLSearchParams(params);

    return urlParams.get('for') != null && urlParams.get('for') === 'digital_advertising';
}


export function setDigitalAdvertisingCart( obj ) {
    digitalAdvertisingCart = obj;
}

export function setMembershipCart( obj ) {
    membershipCart = obj;
}

export function allInGroupAreSelected(group) {
    return  getCart().items[group] != undefined && 
            !jQuery.isEmptyObject(getCart().items[group]) &&
            Object.entries(getCart().items[group]).length == Object.entries(items[group]).length
}

export function applyTempDiscount(couponDetails) {
    
    var tempLength = couponDetails.temp_discount_length;
    var tempUnit = couponDetails.temp_discount_unit;
    var tempEnd = null;
    var tempLengthString = tempLength > 1 ? (tempUnit + 's') : tempUnit;
    var now = new Date();

    switch(tempUnit) {
        case 'day' :
            tempEnd = new Date(now.setDate(now.getDate() + tempLength));
        break;
        case 'week' :
            tempEnd = new Date(now.setDate(now.getDate() + (tempLength * 7)));
        break;
        case 'month' :
            tempEnd = new Date(now.setMonth(now.getMonth() + tempLength));
        break;
    }

    var month = tempEnd.toLocaleString('default', {month: 'long'});
    var day = tempEnd.toLocaleString('default', {day: 'numeric'});
    var year = tempEnd.toLocaleString('default', {year: 'numeric'});
    var temp_end_date = month + ' ' + day + nth(day) +  ', ' + year;
    var monthlyBeforeDiscount = couponDetails.amount + membershipCart.dueMonthly;

    jQuery('#free-trial-subscription-note').remove();
    jQuery('#checkout-due-monthly-col h1').append('<small id="free-trial-subscription-note" class="proxima-nova fw-light d-block">This promotional rate will end with your '+temp_end_date+' bill.</small>');
    jQuery('.couponTimelineNotice').html(`The monthly amount will increase to $${formatAsNumber.format(monthlyBeforeDiscount)} starting on ${temp_end_date}`);
}

export function visitorHasMembership() {
    return getCookie('visitorIsMember') != null;
}

export function setDefaultSelections() {
    if (isDigitalAdsCheckout()) {

    } else {
        jQuery('.due-monthly-total').text(getCart().dueMonthly);
    }
}

export function clearGroupFromCart(group) {
    var groupItems = items[group];
    for (var sku in groupItems) {
        removeItemFromCart(sku, group);
    }
}

export function calcCartItemsHeight() {
    var heights = [];
    var height = 0;
    jQuery('#onetime-cart-items, #monthly-cart-items').each(function(i,elem){
        heights.push(jQuery(elem).outerHeight());
    });
    height = Math.max.apply(Math,heights);
    height += jQuery('.mobile-totals-row').outerHeight();
    height += 20;
    return height;
}
export function openCart() {
    setPreviousCartHeight(jQuery('#membership-signup_slideup-cart').innerHeight());
    var openCartHeight = calcCartItemsHeight()+'px';
    jQuery('#membership-signup_slideup-cart').css({zIndex: '1030'});
    // Makes slideup cart full height on mobile
    // if (window.innerWidth <= 575) {
    //     var navHeight = jQuery('nav.navbar').outerHeight();
    //     var cartContainerHeight = '100vh';
    //     openCartHeight = '100%';
    //     jQuery('#membership-signup_slideup-cart').css({zIndex: '1030'});
    //     jQuery('#membership-signup_slideup-cart').animate({height: cartContainerHeight});
    // }
    jQuery('#cart-items').animate({height: openCartHeight});
}
export function closeCart() {
    // Reverts slideup cart full height on mobile
    // if (window.innerWidth <= 575) {
    //     jQuery('#membership-signup_slideup-cart').css({zIndex: '1029'});
    //     jQuery('#membership-signup_slideup-cart').animate({height: previousCartContainerHeight+'px'});
    // } else {
    //     jQuery('#membership-signup_slideup-cart').css({height: 'auto'});
    // }
    jQuery('#membership-signup_slideup-cart').css({height: 'auto', zIndex: '1029'});
    jQuery('#cart-items').animate({height: '0px'});
}
export function setPreviousCartHeight(h) {
    previousCartContainerHeight = h;
}
export function switchStep(contextID, stepID) {
    var $target = jQuery(contextID + ' #step-'+stepID);
    if ($target.length > 0) {
        jQuery(contextID + ' div.setup-panel div a').removeClass('btn-primary').attr('disabled', 'disabled').addClass('btn-default');
        jQuery(contextID + ' .stepwizard-step a[href="#step-'+stepID+'"]').addClass('btn-primary').removeAttr('disabled');
        jQuery(contextID + ' .step-content, ' + contextID + ' .step-pricing').hide();
        jQuery(contextID + ' .step-'+stepID+'-pricing').show();
        $target.show();
    }
}
export function applyFreeTrial(couponDetails) {

    var trialLength = couponDetails.free_trial.length;
    var trialUnit = couponDetails.free_trial.unit;
    var trialEnd = null;
    var trialLengthString = trialLength > 1 ? (trialUnit + 's') : trialUnit;
    var now = new Date();

    switch(trialUnit) {
        case 'day' :
            trialEnd = new Date(now.setDate(now.getDate() + trialLength));
        break;
        case 'week' :
            trialEnd = new Date(now.setDate(now.getDate() + (trialLength * 7)));
        break;
        case 'month' :
            trialEnd = new Date(now.setMonth(now.getMonth() + trialLength));
        break;
    }

    var month = trialEnd.toLocaleString('default', {month: 'long'});
    var day = trialEnd.toLocaleString('default', {day: 'numeric'});
    var year = trialEnd.toLocaleString('default', {year: 'numeric'});
    var trial_end_date = month + ' ' + day + nth(day) +  ', ' + year;

    jQuery('#free-trial-subscription-note').remove();
    jQuery('#checkout-due-monthly-col h1').prepend('<span id="free-trial-subscription-note" class="proxima-nova fw-light">'+trialLength+ ' ' +trialLengthString+' free, then </span>');

    // If there is no "Due Today" amount, then we can hide the section that references is so we don't show a $0 due today string
    // Otherwise, we need to update the "Due Today" amount to exclude the monthly amount, since that will be charged after the free period is over
    if (getCart().dueToday <= 0) {
        jQuery('#irrelevantForFreeTrialsWithoutOneTimeCharges').hide();
    } else {
        jQuery('#charge-authorization .totalDueToday').text(formatAsNumber.format(getCart().dueToday));
    }

    jQuery('#charge-authorization .dueMonthly').append(', beginning ' + trial_end_date);
    jQuery('#billingDate').text(day + nth(day));

}
export function addItemToCart(sku, group, qty) {

    if (getCart().items[group] == null || group === "support" || group === "website_membership") {
        getCart().items[group] = {};
    }

    var multipleAllowed = items[group][sku].allowMultiple != null && items[group][sku].allowMultiple;
    var quantityInCart = 0;
    var itemIsInCart = getCart().items[group] != null && getCart().items[group][sku] != null;
    if (itemIsInCart) {
        quantityInCart = getCart().items[group][sku].quantity;
    }

    getCart().items[group][sku] = {
        "title": items[group][sku].title,
        "sku": sku,
        "quantity": multipleAllowed !== false ? parseInt(quantityInCart) + qty : qty,
        "price": items[group][sku].price
    };

    if ( typeof fbq === 'function' ) {
        fbq('track', 'AddToCart', {content_ids: [sku]});
    }

    cy_dispatchEvent(document, 'add_to_cart', {sku: sku, title: items[group][sku].title, quantity: qty, price: items[group][sku].price});
    
    calculateCartTotals();
}

export function removeItemFromCart(sku, group, qty = -1) {

    var item_removed = false;

    if (qty > 0) {

        if (getCart().items[group][sku] != null ) {

            var newQuantity = getCart().items[group][sku].quantity - qty;
            item_removed = true;

            if ( (getCart().items[group][sku].quantity - newQuantity) > 0 ) {

                getCart().items[group][sku] = {
                    "sku": sku,
                    "quantity": newQuantity
                };

            } else {

                delete getCart().items[group][sku];

            }

        }

    } else {

        if (getCart().items[group] != null ) {
            item_removed = getCart().items[group][sku] != null;
            delete getCart().items[group][sku];
        }

    }

    if (item_removed) {
        cy_dispatchEvent(document, 'remove_from_cart', {sku: sku, title: items[group][sku].title, quantity: qty, price: items[group][sku].price});
    }

    calculateCartTotals();
}

export function cy_notification(type, message, duration = false, callback = false) {

    var icon = '';
    var classes = 'alert-'+type+' visible';

    if(type == 'success') {
        icon = checkmarkSVG;
    } else if (type == 'danger') {
        icon = xSVG;
    }

    if (!duration) {
        classes += ' alert-dismissible';
        message += '<button type="button" class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button>';
    } else {
        setTimeout(function(){
            jQuery('.global-notification').removeClass('visible');
            if (callback) {
                callback();
            }
        }, duration)
    }

    jQuery('.global-notification').html(icon + message).removeClass('alert-danger alert-success').addClass(classes);
    
}

export function calculateCartTotals() {

    // Cleanup cart codes
    getCart().planCodes = [];

    var cartItems = getCart().items;
    var dueToday = 0;
    var dueMonthly = 0;
    var websiteManagementTotals = {
        monthly: 0,
        oneTime: 0
    };
    var digitalAdvertTotals = {
        monthly: 0,
        oneTime: 0
    }
    var membershipTotal = items.website_membership.basicMembership.price;
    var googleDueToday = 0;
    var googleDueMonthly = 0;
    var facebookDueToday = 0;
    var facebookDueMonthly = 0;
    var slideupCartHTML = {
        monthly: "",
        today: ""
    };
    var addonPopupCarts = {
        adwords: "",
        facebook: ""
    }
    var cartReviewHTML = {
        membershipItems: "",
        digitalAdvertItems: ""
    }
    var cartTotalsHTML = {
        membershipItems: "",
        digitalAdvertItems: ""
    }
    var totalListTemplate = function(title, price,  monthly){

        var priceFormatted = formatAsNumber.format(price);

        if ( price < 0 ) {
            priceFormatted = '- $' + Math.abs(price);
        } else {
            priceFormatted = '$'+priceFormatted;
        }

        if (monthly)
            priceFormatted += '<i class="fw-light">/mo</i>';

        var res = "<div class='row mb-2'><div class='col-8 col-lg-9'><p class='proxima-nova text-dk-grey mb-0 line-height-24'>"+title+"</p></div><div class='col-4 col-lg-3 text-end'><p class='proxima-nova text-dk-grey mb-0 line-height-24'><span>"+priceFormatted+"</p></div></div>";
        return res;

    }
    var reviewListTemplate = function(group, itemSKU, title = '', priceString = ''){

        var cart = !isDigitalAdsCheckout() ? membershipCart : digitalAdvertisingCart;
        var html = "";
        var editSKU = group !== 'support' ? itemSKU : group;
        var itemTitle = title == '' ? items[group][itemSKU].title : title;
        var itemPrice = priceString;
        if ( itemPrice == '' && items[group][itemSKU].price > 0 && cart.items[group][itemSKU].quantity > 0 ) {

            itemPrice = '$' + formatAsNumber.format(items[group][itemSKU].price * cart.items[group][itemSKU].quantity);
            if (items[group][itemSKU].monthly) {
                itemPrice += '/mo';
            }
        }

        html +=
        "<li class='selected'>"+
            "<div class='row align-items-center'>"+
                "<div class='col'>"+
                    "<h3 class='proxima-nova fw-light'>"+itemTitle+"</h3>";
                    if (items[group][itemSKU].note != null) {
                        html += "<p class='mb-0 text-dk-grey'>"+items[group][itemSKU].note+"</p>";
                    }
        html += 
                "<p class='mb-0 text-dk-grey'>"+itemPrice+"</p>"+
            "</div>";
        
        switch(itemSKU) {
            case 'thirtyMins' :
                if ( Object.keys(cart.items["support"]).length == 1 ) {
                    html += 
                    "<div class='col' style='max-width: 150px;'>"+
                        "<button class='btn btn-secondary adjust' data-bs-toggle='modal' data-bs-target='#manageAddons' data-edit-sku='"+editSKU+"'><img src='/wp-content/themes/controlyours/images/signup/arrow-left.svg' /> Edit</button>"+
                    "</div>";
                }
            break;

            case 'eCommerce' :
                html +=
                '<div data-bs-toggle="button"><div class="col btn-group-toggle" style="max-width:185px;"><label for="listeCommerceToggle" class="btn btn-secondary btn-toggle dark-outline signup-checkbox mb-0 w-100 active focus">'+
                    '<input id="listeCommerceToggle" type="checkbox" name="eCommerce" autocomplete="off" value="yes" data-sku="eCommerce" data-group="membershipDetails"><span class="selected"><span class="remove-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.36 28.36"><defs></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M27.86,14.18A13.68,13.68,0,1,1,14.18.5,13.69,13.69,0,0,1,27.86,14.18Z"></path><line class="cls-1" x1="10.3" y1="10.29" x2="18.62" y2="18.62"></line><line class="cls-1" x1="10.3" y1="18.62" x2="18.62" y2="10.29"></line></g></g></svg></span> Remove</span><span class="not-selected"><span class="plus-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.34 28.34"><defs></defs><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M4.15,24.2a14.18,14.18,0,1,1,20,0,14.19,14.19,0,0,1-20,0M23.49,4.85a13.18,13.18,0,1,0,0,18.64,13.19,13.19,0,0,0,0-18.64"></path><rect class="cls-1" x="13.68" y="8.68" width="1" height="11.77"></rect><rect class="cls-1" x="8.29" y="14.07" width="11.77" height="1"></rect></g></g></svg></span> Add</span>'+
                '</label></div></div>';
            break;

            case 'facebookCampaign':
            case 'facebookManagement':
                html += 
                    "<div class='col' style='max-width: 150px;'>"+
                        "<button class='btn btn-secondary adjust' data-bs-toggle='modal' data-bs-target='#facebookAdsModal'><img src='/wp-content/themes/controlyours/images/signup/arrow-left.svg' /> Edit</button>"+
                    "</div>";
            break;

            case 'googleCampaign':
            case 'googleManagement':
                html += 
                "<div class='col' style='max-width: 150px;'>"+
                    "<button class='btn btn-secondary adjust' data-bs-toggle='modal' data-bs-target='#googleAdwordsModal'><img src='/wp-content/themes/controlyours/images/signup/arrow-left.svg' /> Edit</button>"+
                "</div>";
            break;

            default :
                html += 
                "<div class='col' style='max-width: 150px;'>"+
                    "<button class='btn btn-secondary adjust' data-bs-toggle='modal' data-bs-target='#manageAddons' data-edit-sku='"+editSKU+"'><img src='/wp-content/themes/controlyours/images/signup/arrow-left.svg' /> Edit</button>"+
                "</div>";
            break;
        }

        html += 
            "</div>"+
        "</li>";

        return html;

    }

    if (!isDigitalAdsCheckout()) {
        // Add website_membership 30 minutes to membership details
        var supportItems = cartItems.support;
        var completeSupportItems = Object.assign({thirtyMins: items.support.thirtyMins}, supportItems);
        cartItems["support"] = completeSupportItems;

        // If eCommerce is already in the cart, hide the 'add' item in the right cart column, otherwise show it.
        var eCommerceIsSelected = cartItems["membershipDetails"] !== undefined && cartItems["membershipDetails"]["eCommerce"] !== undefined;
        jQuery('#eCommerceOffer').toggle( !eCommerceIsSelected );

    }
    // Used to unhide sticky cart when cart contents change.
    // if (membershipCart.dueMonthly !== 185 && membershipCart.dueToday !== 185) {
    //     jQuery('#membership-signup_slideup-cart').removeClass('hidden');
    // }

    slideupCartHTML.monthly += "<ul>";
    slideupCartHTML.today += "<ul>";

    // Reorders the Digital Advertising items in the cart according to David's precise specifications 🙃
        if (cartItems.facebook != null) {

            var facebookItemsOrder = {}
            if ( cartItems.facebook.facebookCampaign != null ) {
                facebookItemsOrder['facebookCampaign'] = null;
            }
            if ( cartItems.facebook.facebookManagement != null ) {
                facebookItemsOrder['facebookManagement'] = null;
            }

            var reorderedFacebook = Object.assign(facebookItemsOrder, cartItems.facebook);
            cartItems.facebook = reorderedFacebook;

        }

        if (cartItems.google != null) {

            var googleItemsOrder = {}
            if ( cartItems.google.googleCampaign != null ) {
                googleItemsOrder['googleCampaign'] = null;
            }
            if ( cartItems.google.googleManagement != null ) {
                googleItemsOrder['googleManagement'] = null;
            }

            var reorderedGoogle = Object.assign(googleItemsOrder, cartItems.google);
            cartItems.google = reorderedGoogle;

        }

    for (var group in cartItems) {
        if (cartItems.hasOwnProperty(group)) {
            var skus = cartItems[group];
            for (var sku in skus) {

                var quantity = skus[sku].quantity != null ? skus[sku].quantity : 1;
                var itemTitle = items[group][sku].title;
                var itemPrice = items[group][sku].price * quantity;
                var isMonthly = items[group][sku].monthly;
                var planCode = items[group][sku].planCode;
                var itemListTemplate = "<li>";
                    itemListTemplate += "<h6 class='proxima-nova fw-light'>"+itemTitle+"</h6>";
                    itemListTemplate += "$"+itemPrice;
                    itemListTemplate += "</li>";

                if (planCode != null) {
                    getCart().planCodes.push(planCode);
                }

                if (items[group][sku].monthly) {
                    dueMonthly += itemPrice;
                    if (itemPrice > 0) {
                        
                        slideupCartHTML.monthly += itemListTemplate;
                       
                    }
                } else {
                    slideupCartHTML.today += itemListTemplate;
                    dueToday += itemPrice;
                }

                if (group === "google") {
                    if (items[group][sku].monthly) {
                        googleDueMonthly += itemPrice;
                        digitalAdvertTotals.monthly += itemPrice;
                    } else {
                        googleDueToday += itemPrice;
                        digitalAdvertTotals.oneTime += itemPrice;
                    }
                    addonPopupCarts.adwords += itemListTemplate;
                    cartTotalsHTML.digitalAdvertItems += totalListTemplate(itemTitle, itemPrice, isMonthly);
                    cartReviewHTML.digitalAdvertItems += reviewListTemplate(group, sku);
                }

                if (group === "facebook") {
                    if (items[group][sku].monthly) {
                        facebookDueMonthly += itemPrice;
                        digitalAdvertTotals.monthly += itemPrice;
                    } else {
                        facebookDueToday += itemPrice;
                        digitalAdvertTotals.oneTime += itemPrice;
                    }
                    addonPopupCarts.facebook += itemListTemplate;
                    cartTotalsHTML.digitalAdvertItems += totalListTemplate(itemTitle, itemPrice, isMonthly);
                    cartReviewHTML.digitalAdvertItems += reviewListTemplate(group, sku);
                }

                if (group === "website_membership") {
                    cartTotalsHTML.membershipItems += totalListTemplate(itemTitle, itemPrice, isMonthly);
                    websiteManagementTotals.monthly += itemPrice;
                }

                if (group === "support" || group === "membershipDetails") {

                    websiteManagementTotals.monthly += itemPrice;

                    var thisItemTitle = items[group][sku].title;
                    var subItemtitle = thisItemTitle;
                    var thisItemPrice = '';

                    if (itemPrice > 0) {
                        membershipTotal += itemPrice;
                        thisItemPrice += '$'+itemPrice;
                        if (items[group][sku].monthly) {
                            thisItemPrice += "<i>/mo</i>";
                        }
                        if ( group !== 'support' && sku !== 'eCommerce' ) {

                            if (quantity > 0) {
                                thisItemTitle += 's';
                            }
                            if (quantity > 1) {
                                subItemtitle += 's';
                            }
                            
                            thisItemPrice = quantity + " additional " + subItemtitle + ' at ' + thisItemPrice;
                            thisItemTitle = (parseInt(quantity) + 1) + " " + thisItemTitle;
                        }
                    
                    }

                    cartTotalsHTML.membershipItems += totalListTemplate(thisItemTitle, itemPrice, isMonthly);
                    cartReviewHTML.membershipItems += reviewListTemplate(group, sku, thisItemTitle, thisItemPrice);

                }

            }
        }
    }

    // Check for and apply discounts
    if (getCart().discount != null && getCart().discount != false) {
        
        var discount = getCart().discount;
        var plans = discount.plans;

        jQuery('#couponCode').val(discount.code);
        jQuery('#clearCoupon').show();

        if (discount.amount > 0) {
            var isPercent = discount.amount < 1;

            for (var i in plans) {
                var plan = plans[i];
                switch(plan) {
                    case 'website_membership':
                        var dueMonthlyAmt = websiteManagementTotals.monthly;
                        websiteManagementTotals.monthly = isPercent ? (dueMonthlyAmt - (dueMonthlyAmt * discount.amount)) : (dueMonthlyAmt - discount.amount);
                        cartTotalsHTML.membershipItems += totalListTemplate( "<strong>" + discount.code + "</strong> coupon", -Math.abs(discount.amount), true);
                        slideupCartHTML.monthly +=  "<li>" +
                                                        "<h6 class='proxima-nova fw-light'>Coupon: <strong>"+discount.code+"</strong></h6>" +
                                                        "- $" + Math.abs(discount.amount) +
                                                    "</li>";
                    break;
                    case 'facebook-subscription-2022':
                    case 'facebook-setup-and-subscription-2022':
                    case 'facebook-setup-only-2022':
                    case 'google-and-facebook-subscription-2022':
                    case 'google-and-facebook-setup-and-subscription-2022':
                    case 'google-subscription-2022':
                    case 'google-setup-and-subscription-2022':
                    case 'google-setup-only-2022':

                        var digitalAdvertisingOneTimeTotal = digitalAdvertTotals.oneTime;
                        var digitalAdvertisingMonthlyTotal = digitalAdvertTotals.monthly;

                        if (discount.single_use) {
                            digitalAdvertTotals.oneTime = isPercent ? (digitalAdvertisingOneTimeTotal - (digitalAdvertisingOneTimeTotal * discount.amount)) : (digitalAdvertisingOneTimeTotal - discount.amount);
                        } else {
                            digitalAdvertTotals.monthly = isPercent ? (digitalAdvertisingMonthlyTotal - (digitalAdvertisingMonthlyTotal * discount.amount)) : (digitalAdvertisingMonthlyTotal - discount.amount);
                        }

                        cartTotalsHTML.digitalAdvertItems += totalListTemplate("<strong>" + discount.code + "</strong> coupon", -Math.abs(discount.amount), false);

                    break;
                }
            }

        }

    }

    //cartTotalsHTML.totalItems = totalListTemplate(items.website_membership.basicMembership.title, membershipTotal, true) + cartTotalsHTML.totalItems;

    slideupCartHTML.monthly += "</ul>";
    slideupCartHTML.today += "</ul>";

    // Updates visible totals on both 'Get Started' and 'Your Cart' pages.
    getCart().dueMonthly = websiteManagementTotals.monthly + digitalAdvertTotals.monthly;
    getCart().dueToday = websiteManagementTotals.oneTime + digitalAdvertTotals.oneTime;
        jQuery('.due-monthly-total, .dueMonthly').text(formatAsNumber.format(getCart().dueMonthly));
        jQuery('.due-today-total, .dueToday').text(formatAsNumber.format(getCart().dueToday));
        jQuery('.totalDueToday').text(formatAsNumber.format(getCart().dueToday + getCart().dueMonthly));
        jQuery('.websiteManagementMonthlyTotal').text(formatAsNumber.format(websiteManagementTotals.monthly));
        jQuery('.digitalAdvertOneTimeTotal').text(formatAsNumber.format(digitalAdvertTotals.oneTime));
        jQuery('.digitalAdvertMonthlyTotal').text(formatAsNumber.format(digitalAdvertTotals.monthly));
        jQuery('#googleDueToday').text('$'+formatAsNumber.format(googleDueToday));
        jQuery('#googleDueMonthly').text('$'+formatAsNumber.format(googleDueMonthly));
        jQuery('#facebookDueToday').text('$'+formatAsNumber.format(facebookDueToday));
        jQuery('#facebookDueMonthly').text('$'+formatAsNumber.format(facebookDueMonthly));

    

    jQuery('#onetime-cart-items').html(slideupCartHTML.today);
    jQuery('#monthly-cart-items, #groupItems').html(slideupCartHTML.monthly);

    var weHaveFacebookAddons = getCart().items["facebook"] != undefined && !jQuery.isEmptyObject(getCart().items["facebook"]);
    var weHaveGoogleAddons = getCart().items["google"] != undefined  && !jQuery.isEmptyObject(getCart().items["google"]);

    // Hide Google/Facebook addon CTAs from cart page if all are selected.
    // TODO: move into a function
    var allFacebookAddonsSelected = allInGroupAreSelected("facebook");
    var allGoogleAddonsSelected = allInGroupAreSelected("google");

    jQuery('#websiteMembershipOffers').toggle(!isDigitalAdsCheckout() && !((weHaveFacebookAddons && weHaveGoogleAddons) && eCommerceIsSelected));
    jQuery('#digitalAdvertAddonsCartRow').toggle(!(weHaveFacebookAddons && weHaveGoogleAddons));
    jQuery('#facebookAdsOffer').toggle( !weHaveFacebookAddons );
    jQuery('#googleAdsOffer').toggle( !weHaveGoogleAddons );

    if (allFacebookAddonsSelected) {
        jQuery('#googleAdsOffer').removeClass('pl-lg-4');
    } else {
        jQuery('#googleAdsOffer').addClass('pl-lg-4');
    }

    if (weHaveFacebookAddons || weHaveGoogleAddons) {
        jQuery('#digitalAdvertAddonsCartRow').addClass('col-lg-6 pl-lg-4');
        jQuery('#facebookAdsOffer, #googleAdsOffer').removeClass('col-lg-6 pr-lg-4 pl-lg-4').addClass('col-12');
    } else {
        jQuery('#digitalAdvertAddonsCartRow').removeClass('col-lg-6 pl-lg-4');
        jQuery('#facebookAdsOffer').removeClass('col-12 pl-lg-4').addClass('col-lg-6 pr-lg-4');
        jQuery('#googleAdsOffer').removeClass('col-12 pr-lg-4').addClass('col-lg-6 pl-lg-4');
    }
    jQuery("#digitalAdvertItemsReview").html(cartReviewHTML.digitalAdvertItems);
    jQuery("#digitalAdvertItemsReviewContainer").toggle(weHaveFacebookAddons || weHaveGoogleAddons);
    

    jQuery("#membershipItemsReview").html(cartReviewHTML.membershipItems);

    jQuery("#membershipItemsTotal").html(cartTotalsHTML.membershipItems !== "" ? cartTotalsHTML.membershipItems : '<p class="text-dk-grey">None selected</p>');
    jQuery("#digitalAdvertItemsTotal").html(cartTotalsHTML.digitalAdvertItems !== "" ? cartTotalsHTML.digitalAdvertItems : '<p class="text-dk-grey">None selected</p>');

    jQuery('.digital-advertising-total').toggle( digitalAdvertTotals.monthly > 0 || digitalAdvertTotals.oneTime > 0 );
    jQuery('.website-membership-total').toggle( websiteManagementTotals.monthly > 0 || websiteManagementTotals.oneTime > 0 );
    
    // Modify cart messaging based on any coupons present
        if ( getCart().discount != null && getCart().discount != false ) {
            if ( getCart().discount.free_trial != null ) {

                applyFreeTrial( getCart().discount );

            } else if ( getCart().discount.temp_discount != null ) {

                applyTempDiscount( getCart().discount );
                
            }
        }

    if (jQuery('#cart-items').outerHeight() > 0) {
        openCart();
    }

    if (!isDigitalAdsCheckout()) {
        setCookie(membershipCartCookieName, membershipCart, 30);
        setCookie('lastCart', 'membership', 30);
    } else {
        setCookie(digitalAdvertisingCartCookieName, digitalAdvertisingCart, 30);
        setCookie('lastCart', 'digitalAdvertising', 30);
    }

    return !isDigitalAdsCheckout() ? membershipCart : digitalAdvertisingCart;

}